import { BadgeCheck, MapPin, ShieldCheck } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const FACT_ICONS = [BadgeCheck, MapPin, ShieldCheck];

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <div className="relative mx-auto max-w-md lg:max-w-none">
              <div className="overflow-hidden rounded-t-[200px] rounded-b-3xl border border-gold/30">
                <img
                  src="https://images.unsplash.com/photo-1562191326-0da0767cfffe?q=80&w=1400&auto=format&fit=crop"
                  alt={t.about.islandAlt}
                  className="h-[420px] w-full object-cover transition-transform duration-[2s] hover:scale-105 sm:h-[520px]"
                  data-testid="about-island-image"
                />
              </div>
              <div
                className="absolute -bottom-6 left-1/2 w-[86%] -translate-x-1/2 rounded-2xl border border-gold/25 bg-navy2/95 p-5 text-center shadow-2xl backdrop-blur-md"
                data-testid="about-quote-card"
              >
                <p className="font-display text-xl italic leading-snug text-gold-light">
                  &ldquo;{t.about.quote}&rdquo;
                </p>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.26em] text-cream/50">{t.about.quoteBy}</p>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <Eyebrow className="mb-5">{t.about.eyebrow}</Eyebrow>
              <h2 className="font-display text-4xl font-semibold leading-[1.05] text-cream sm:text-5xl lg:text-6xl">
                {t.about.titleA}
                <br />
                <span className="italic text-gold-grad">{t.about.titleB}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-7 space-y-5 text-base leading-relaxed text-cream/70">
                <p>{t.about.p1}</p>
                <p>{t.about.p2}</p>
                <p>{t.about.p3}</p>
              </div>
            </Reveal>

            <div className="mt-10 grid gap-4 sm:grid-cols-3" data-testid="about-facts">
              {t.about.facts.map((fact, i) => (
                <Reveal key={fact.value} delay={0.1 + i * 0.08}>
                  <div className="card-lift h-full rounded-2xl border border-cream/10 bg-navy2/60 p-5">
                    {(() => { const Icon = FACT_ICONS[i]; return <Icon className="h-5 w-5 text-gold" />; })()}
                    <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.22em] text-cream/45">{fact.label}</p>
                    <p className="mt-1.5 font-display text-lg font-semibold text-cream">{fact.value}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
